import { DirectionsRunRounded, AspectRatioRounded } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import { Box } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';

const FirebaseDrillControls = () => {
  const dispatch = useDispatch();
  const handleAspectRatio = useAspectRatio();
  const { preferences } = useSelector((state) => state.currentUser);
  const firebaseData = useSelector((state) => state.firebaseDrill);

  return (
    <Box
    sx={{
      width: 'fit-content',
      display: 'flex',
      gap: '24px',
      marginLeft: 'auto'
    }}
    >
      <Box display="flex">
        <Button color="graypart" disabled={firebaseData.loading} onClick={() => {
          dispatch({
            type: REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_SEARCH
          });
        }}>
          <DirectionsRunRounded />
        </Button>
        <IconButton
          edge="end"
          onClick={() => {
            handleAspectRatio(!preferences.aspectChanged);
          }}
        >
          <AspectRatioRounded />
        </IconButton>
      </Box>
    </Box>
  );
};

export default FirebaseDrillControls;
